import { Typography } from "antd";

import "./QuickLink.scss";

type Props = {
  title: string;
  description: string;
  handleClick: () => void;
};

const QuickLink = ({ title, description, handleClick }: Props) => (
  <div className="quick-link-wrapper" onClick={handleClick}>
    <Typography.Title level={4} className="quick-link-title">
      {title}
    </Typography.Title>
    <Typography.Text className="quick-link-description">{description}</Typography.Text>
  </div>
);

export default QuickLink;
